



































































































































import {Component, Prop, PropSync, Vue,} from "vue-property-decorator";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import ProbabilisticChart from "@/modules/lcca/views/components/ProbablisticChart.vue";
import {getPdfFromDistribution} from "@/lib/monteCarlo/pdf";
import QuickHelp from "@/views/components/input/QuickHelp.vue";
import {DistributionTypes, IDistribution} from "@/lib/monteCarlo/interfaces";
import {v4} from "uuid";

const echarts = require("echarts");

@Component({
  components: {
    QuickHelp,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class ProbabilisticInputs extends Vue {
  @Prop() title!: string;

  @Prop() id!: string;

  @PropSync("value") syncedValue!: IDistribution;

  @Prop({default: "% per Year"}) xLabel!: string;

  @Prop({default: "%"}) unit!: string;

  @Prop() validations!: any;

  showChart = true;

  updateCounter = 0;

  distDetails = {
    text: "",
    prob: "",
    min: false,
    mean: false,
    mode: false,
    max: false,
    std: false,
    location: false,
    shape: false,
  };

  distributions = [
    {
      text: "Deterministic",
      prob: "deterministic",
      min: false,
      mean: true,
      mode: false,
      max: false,
      std: false,
      location: false,
      shape: false,
    },
    {
      text: "Uniform",
      prob: "uniform",
      min: true,
      mean: false,
      mode: false,
      max: true,
      std: false,
      location: false,
      shape: false,
    },
    {
      text: "Normal",
      prob: "normal",
      min: false,
      mean: true,
      mode: false,
      max: false,
      std: true,
      location: false,
      shape: false,
    },
    {
      text: "Triangular",
      prob: "triangular",
      min: true,
      mean: false,
      mode: true,
      max: true,
      std: false,
      location: false,
      shape: false,
    },
    {
      text: "LogNormal",
      prob: "lognormal",
      min: false,
      mean: false,
      mode: false,
      max: false,
      std: false,
      location: true,
      shape: true,
    },
    {
      text: "Truncated Normal",
      prob: "truncatednormal",
      min: true,
      mean: true,
      mode: false,
      max: true,
      std: true,
      location: false,
      shape: false,

    },
    {
      text: "Truncated Lognormal",
      prob: "truncatedlognormal",
      min: true,
      mean: true,
      mode: false,
      max: true,
      std: false,
      location: true,
      shape: true,
    },
  ];

  get mean() {
    return this.syncedValue.mean;
  }

  get distributionOptions() {
    return this.distributions.map((D) => ({value: D.prob, text: D.text}));
  }

  get distribution() {
    return this.syncedValue;
  }

  get echartId() {
    const uuid = v4()
    return `${this.id}-echart-${uuid}`;
  }

  sync() {
    this.updateCounter += 1;
    this.$emit("input");
  }

  update() {
    // this.chart.resize()
    this.createEchart();
  }

  created() {
  }

  mounted() {
    this.updateDistDetails();
  }

  updated() {
    this.update();
    this.updateDistDetails();
  }


  togglePlot() {
    this.showChart = !this.showChart;
  }

  updateDistDetails() {
    const details = this.distributions.filter((D) => D.prob === this.syncedValue.prob)[0];

    this.updateCounter += 1;
    if (details) {
      this.distDetails = details;
    } else {
      this.distDetails = {
        text: "",
        prob: "",
        min: false,
        mean: false,
        mode: false,
        max: false,
        std: false,
        location: false,
        shape: false,
      };
    }
    this.update();
  }

  chart: any = null;

  createEchart() {
    if (this.chart === null) {
      const el = document.getElementById(this.echartId);
      this.chart = echarts.init(el);
    }

    // const xMax = () => {
    //   if (this.syncedValue.prob === DistributionTypes.lognormal){
    //     return Math.exp(this.syncedValue.mean || 1) * 2;
    //   } else {
    //     return this.syncedValue.
    //   }
    // }

    const that = this;

    const {syncedValue} = this;

    const pdf = this.pdfData;

    const series = (() => {
      // Deterministic
      if (syncedValue.prob === DistributionTypes.deterministic) {
        return [
          {
            type: "scatter",
            data: [[syncedValue.mean, 1]],
            symbolSize: 15,
          },
          // {
          //   type: 'line',
          //   data: [
          //     [syncedValue.mean, 0],
          //     [syncedValue.mean, 1],
          //   ],
          //   showsymbol: false,
          //   areastyle: {},
          // },
        ];
      }

      // Regular probability distribution
      return [
        {
          type: "line",
          data: pdf,
          showSymbol: false,
          areaStyle: {},
        },
      ];
    })();

    this.chart.setOption({
      title: {
        show: false,
      },
      grid: {top: 10, right: 20},
      animation: false,
      xAxis: {
        name: this.xLabel,
        nameLocation: "middle",
        nameGap: 30,
        type: "value",
        max() {
          if (that.distDetails.max) {
            return (that.syncedValue.max ? that.syncedValue.max : 1) * 1.05;
          }
          if (that.distDetails.prob === DistributionTypes.deterministic) {
            return 2 * (that.syncedValue.mean || 1);
          }
          return Math.round(that.pdfData[that.pdfData.length - 1][0]);
          // return 150;
        },
      },
      yAxis: {
        name: "Probability",
        nameLocation: "middle",
        nameGap: 20,
        type: "value",
        scale: true,
        min: 0,
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      series,

    });
  }

  get pdfData() {
    return getPdfFromDistribution(this.syncedValue);
  }
}
